import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card';

import { doGetWismoStats } from '../../../modules/wismo/api';
import { WismoStats } from '../../../modules/wismo/types';
import { Badge } from '../../ui/badge';
import { Separator } from '../../ui/separator';

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export const Wismo = () => {
  const history = useHistory();
  const [wismo, setWismo] = useState<WismoStats>(null);
  const [selectedStatus, setSelectedStatus] = useState('');

  useEffect(() => {
    const doit = async () => {
      const res = await doGetWismoStats();
      console.log(res.response);
      setWismo(res?.response as any);
    };
    doit();
  }, []);

  const gotoOrder = (orderId: string) => {
    history.push(`/orders/${orderId}`);
  };

  const pretty = (status: string) => status.replace(/_/g, ' ');
  return (
    <Card className="min-h-[400px]">
      <CardHeader>
        <CardTitle>Wismo</CardTitle>
        <CardDescription>Some data about wismo requests</CardDescription>
      </CardHeader>
      <CardContent>
        <h3 className="font-bold ">Top 3 questions clicked</h3>
        <ul>
          {wismo?.top3.map((t) => (
            <li key={t.question} className="my-2">
              <div className="flex justify-between">
                <div>
                  <strong>{t.count}</strong> x <em>&quot;{t.question}&quot;</em>
                </div>
                <Badge variant="secondary">{t.status}</Badge>
              </div>
            </li>
          ))}
        </ul>
        <Separator className="my-4" />
        <h3 className="font-bold ">Most recent open questions asked</h3>

        <ul>
          {(wismo?.openQuestion || []).map((t) => (
            <li key={t.question} className="my-2">
              <div className="flex justify-end">
                <div className="flex flex-grow justify-between">
                  <em>&quot;{t.question}&quot;</em>
                  <a onClick={() => gotoOrder(t.orderId)}>go to order {t.orderId}</a>
                </div>
                <Badge variant="secondary" className="ml-2">
                  {pretty(t.status)}
                </Badge>
              </div>
            </li>
          ))}
        </ul>
        <Separator className="my-4" />
        <div className="flex justify-between">
          <h3 className="font-bold ">Statistics per status</h3>
          {wismo?.stats && (
            <Select value={selectedStatus} onValueChange={(newValue) => setSelectedStatus(newValue)}>
              <SelectTrigger className="w-[220px] h-6 flex items-center">
                <SelectValue placeholder="Select order status" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {Object.keys(wismo?.stats).map((status) => (
                    <SelectItem value={status} key={status}>
                      {pretty(status)}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          )}
        </div>
        <ul className="mt-4">
          {wismo?.stats?.[selectedStatus] &&
            Object.entries(wismo?.stats?.[selectedStatus]).map(([question, count]) => (
              <li key={question} className="my-2">
                <div className="flex justify-between">
                  <div>
                    <strong>{count}</strong> x <em>&quot;{question}&quot;</em>
                  </div>
                  <Badge variant="secondary">{pretty(selectedStatus)}</Badge>
                </div>
              </li>
            ))}
        </ul>
      </CardContent>
    </Card>
  );
};
